(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  function syncFooterAccordionAt749() {
    const shouldBeOpen = window.innerWidth >= 749;
    document.querySelectorAll('.footer-content details').forEach((details) => {
      details.open = shouldBeOpen;
    });
  }

  window.addEventListener('resize', syncFooterAccordionAt749);
  document.addEventListener('DOMContentLoaded', syncFooterAccordionAt749);
  syncFooterAccordionAt749();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
